<template>
  <sui-form-field :width="field.width || 16" :required="field.required" v-if="!field.hidden">
    <label v-show="field.label">
      {{field.label}}
      <span class="tooltip" data-inverted data-position="left center" :data-tooltip="field.warning" v-if="field.warning"><i class="warning sign yellow fitted icon" /></span>
      <span class="tooltip" data-inverted data-position="left center" :data-tooltip="tooltip" v-if="tooltip"><i class="help circle blue fitted icon" /></span>
    </label>
    <codemirror class="commands" v-model="$attrs.value" :options="options" @input="onInput" @ready="onCmReady" />
    <small v-if="field.examples && !field.readonly">
      Example{{field.examples.length > 1 ? 's' : ''}}:
      <span class="example" v-for="example in field.examples" :key="example" @click.prevent="set(example)">{{example}}</span>
    </small>
  </sui-form-field>
</template>

<script>
  import FormField from '@/mixins/FormField'

  export default {
    name: 'FormServiceCommand',
    mixins: [
      FormField,
    ],
    props: {
      syntaxis: {
        type: String,
        required: false,
      }
    },
    computed: {
      options() {
        return {
          lineNumbers: true,
          mode: this.field.syntaxis || this.syntaxis,
        }
      },
    },
    methods: {
      onCmReady(codemirror) {
        setTimeout(() => {
          codemirror.refresh()
        }, 500)
      },
    },
  }
</script>

<style scoped>
  .tooltip { float: right; }
  .example { margin-left: .1em; color: #48c; cursor: pointer; }
  .example:after { content: ", "; color: #000; }
  .example:hover { color: #6ae; }
  .example:last-child:after { content: ""; }
</style>
